module.exports = __webpack_public_path__ + "static/media/charlene_4.50ba221c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MoreWork/assets/charlene_4.jpg
// module id = 478
// module chunks = 0